<template>
  <div
    id="circularMenu"
    class="circular-menu"
    :class="{ active: isMenuActive }"
  >
    <a class="floating-btn" @click="toggleMenu">
      <img class="robot-icon" alt="Ayuda" src="@/assets/icons/help/robot_pequeno.png" />
    </a>
    <menu class="items-wrapper">
      <!-- Cada opción es ahora un grupo de icono y texto -->
      <div class="menu-option-group">
        <a href="#" class="menu-item-icon" @click.prevent="openChat">
          <img class="item-icon" alt="Chat" src="@/assets/icons/help/icono_chat.svg" />
        </a>
        <span class="menu-item-label" @click.prevent="openChat">Chat On-Line</span>
      </div>

      <div class="menu-option-group">
        <router-link to="/contact-me" class="menu-item-icon" @click="isMenuActive = false">
          <img
            class="item-icon"
            alt="Email"
            src="@/assets/icons/help/icono_e-mail.svg"
          />
        </router-link>
        <span class="menu-item-label" @click="isMenuActive = false">E-mail</span>
      </div>

      <div class="menu-option-group">
        <a href="/documents/Preguntas_Frecuentes_Banco_Caribe.pdf" target="_blank" class="menu-item-icon" @click="isMenuActive = false">
          <img class="item-icon" alt="FAQ" src="@/assets/icons/help/icono_preguntas.svg" />
        </a>
        <span class="menu-item-label" @click="isMenuActive = false">F.A.Q</span>
      </div>
    </menu>
  </div>
</template>

<script>
import { useAuthStore } from "@/stores/authstore";
import { mapState } from "pinia";

export default { /* Renombrado */
  name: "CircularHelpMenuComp",
  data() {
    return {
      isMenuActive: false,
      chatScriptLoaded: false,
    };
  },
  computed: {
    ...mapState(useAuthStore, ["companySettings"]),
  },
  methods: {
    toggleMenu() {
      this.isMenuActive = !this.isMenuActive;
    },
    openChat() {
      // Si el script ya está, lo maximizamos. Si no, lo cargamos y abrimos.
      this.isMenuActive = false;
      if (window.LiveChatWidget) {
        window.LiveChatWidget.call("maximize");
      } else {
        this.initLiveChat(() => {
          // Pequeño delay para asegurar que el widget se inicialice
          setTimeout(() => {
            window.LiveChatWidget.call("maximize");
          }, 500);
        });
      }
    },
    initLiveChat(callback) {
      if (window.__lc_init_triggered || window.LiveChatWidget) return;
      window.__lc_init_triggered = true;

      const vm = this;
      window.__lc = window.__lc || {};
      window.__lc.license = 13090239;

      (function (n, t, c) {
        function i(n) {
          return e._h ? e._h.apply(null, n) : e._q.push(n);
        }
        var e = {
          _q: [],
          _h: null,
          _v: "2.0",
          on: function () {
            i(["on", c.call(arguments)]);
          },
          once: function () {
            i(["once", c.call(arguments)]);
          },
          off: function () {
            i(["off", c.call(arguments)]);
          },
          get: function () {
            if (!e._h)
              throw new Error(
                "[LiveChatWidget] You can't use getters before load.",
              );
            return i(["get", c.call(arguments)]);
          },
          call: function () {
            i(["call", c.call(arguments)]);
          },
          init: function () {
            var n = t.createElement("script");
            n.async = !0;
            n.type = "text/javascript";
            n.src = "https://cdn.livechatinc.com/tracking.js";
            t.head.appendChild(n);
            n.onload = () => {
              vm.chatScriptLoaded = true;
              if (callback) callback();
            };
          },
        };
        !n.__lc.asyncInit && e.init();
        n.LiveChatWidget = n.LiveChatWidget || e;
      }).call(window, window, document, [].slice);
    },
  },
};
</script>

<style scoped>
.circular-menu {
  position: fixed;
  bottom: 5em; /* Ajustado a 5em */
  right: 5em; /* Ajustado a 5em */
  z-index: 1000;
  width: 3.5em; /* Asegura el centrado del contenido */
  height: 3.5em;
}

.circular-menu .floating-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.5em;
  height: 3.5em;
  border-radius: 50%;
  background-color: white;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  color: hsl(0, 0%, 100%);
  box-sizing: border-box;
  border: 2px solid var(--color-acento-primario); /* Borde look & feel */
  cursor: pointer;
  outline: 0;
  transition: all 0.3s ease; /* Transición para el borde y otros efectos */
}

.robot-icon {
  width: 30px;
  height: auto;
  /* Eliminado margin-top: -8px; para centrado */
}

.circular-menu.active .floating-btn {
  transform: none; /* Asegura que no haya rotación */
}

.circular-menu:after {
  display: block;
  content: " ";
  width: 3.5em;
  height: 3.5em;
  border-radius: 50%;
  position: absolute;
  top: 0;
  right: 0;
  z-index: -2;
  background-color: transparent;
  transition: all 0.3s ease;
}

.circular-menu.active:after {
  transform: scale3d(8.5, 8.5, 1);
  transition-timing-function: cubic-bezier(0.68, 1.55, 0.265, 1);
  background-color: hsla(0, 100%, 99.8%, 0.94);
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
}

.circular-menu .items-wrapper {
  padding: 0;
  margin: 0;
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s linear 300ms, opacity 300ms;
}

.circular-menu.active .items-wrapper {
  visibility: visible;
  opacity: 1;
  transition: visibility 0s linear 0s, opacity 300ms;
}

.circular-menu .menu-option-group {
  position: absolute;
  top: 0;
  right: 0;
  z-index: -1;
  display: flex;
  align-items: center;
  flex-direction: row-reverse; /* Texto a la izquierda del icono */
  gap: 1em;
  opacity: 0;
  transition: opacity 0.3s ease, transform 0.3s ease;
  pointer-events: none;
}

.circular-menu.active .menu-option-group {
  opacity: 1;
  pointer-events: auto;
}

.circular-menu .menu-item-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3em; /* Tamaño de la burbuja del icono */
  height: 3em;
  border-radius: 50%;
  background-color: white;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  text-decoration: none;
}

.circular-menu .menu-item-icon:hover {
  background-color: #f0f2f5;
}

.item-icon {
  width: 20px; /* Iconos más pequeños */
  height: 20px; /* Iconos más pequeños */
}

.circular-menu .menu-item-label {
  white-space: nowrap;
  color: var(--color-acento-secundario);
  font-size: 0.9rem;
  font-weight: normal; /* Texto sin negrita */
  opacity: 0;
  transition: opacity 0.3s ease;
  cursor: pointer;
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.8); /* Mejora legibilidad sobre fondos claros */
}

.circular-menu.active .menu-item-label {
  opacity: 1;
}

/* Posicionamiento de los iconos al abrirse */
.circular-menu.active .menu-option-group:nth-child(1) {
  transform: translate3d(-0.0em, -8.5em, 0); /* Chat (Equidistante a 8.5em) */
}
.circular-menu.active .menu-option-group:nth-child(2) {
  transform: translate3d(-6.7em, -5.8em, 0); /* Teléfono (Equidistante a 5.7em) */
}
.circular-menu.active .menu-option-group:nth-child(3) {
  transform: translate3d(-8.0em, 0.0em, 0); /* Email (Centro del arco a 8.5) */
}
</style>
